import PropTypes from 'prop-types'
import React from 'react'
import MapProducers from './MapProducers'

const MapProducersContainer = ({
  updateBounds,
  coordinates,
  bounds,
  data,
  loading
}) => {
  return (
    <MapProducers
      coordinates={coordinates}
      bounds={bounds}
      updateBounds={updateBounds}
      producers={!loading && !coordinates ? data.producers : []}
      loading={loading}
    />
  )
}

export default MapProducersContainer

MapProducersContainer.propTypes = {
  bounds: PropTypes.array,
  coordinates: PropTypes.array,
  data: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  updateBounds: PropTypes.func.isRequired
}
